var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7376 0.478889H4.4951C3.81439 0.477903 3.14731 0.669714 2.57108 1.03212C1.99486 1.39453 1.53304 1.91271 1.2391 2.52669C0.895003 3.25518 0.762471 4.06568 0.856606 4.86582C0.950741 5.66597 1.26776 6.42358 1.77153 7.05232L10.3928 17.4961C10.7311 17.8865 11.1494 18.1996 11.6193 18.4141C12.0892 18.6287 12.5998 18.7397 13.1163 18.7397C13.6329 18.7397 14.1435 18.6287 14.6134 18.4141C15.0833 18.1996 15.5016 17.8865 15.8399 17.4961L24.4612 7.05232C24.9649 6.42358 25.2819 5.66597 25.3761 4.86582C25.4702 4.06568 25.3377 3.25518 24.9936 2.52669C24.6996 1.91271 24.2378 1.39453 23.6616 1.03212C23.0854 0.669714 22.4183 0.477903 21.7376 0.478889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/downArrowIcon.48c4990f109a1a876680046ca95de58d.svg";
export { ForwardRef as ReactComponent };